import React from 'react';
import '../css/animate.css';
import '../css/barvy.css';
import '../css/style.css';
import '../css/loader.css';
import pngSrc from "../images/nukeproof.png";

// Preload the PNG image to ensure it shows immediately
const preloadedImage = new Image();
preloadedImage.src = pngSrc;

function App({ isHiding = false }) {
  return (
    <div className={`loader-lubau ${isHiding ? 'fade-out' : ''}`} style={{ backgroundColor: "white" }}>
        <div>
            <div className="animated-logo">
                <img src={pngSrc} alt="Načítání..." />
            </div>
        </div>
    </div>
  );
}

export default App;
